import { addDirectionsLink, cleanUpBrokenCharacters, findCurrentOpeningStatus, getStoreDistance } from './index';

if (!customElements.get('store-details')) {
	class StoreDetails extends HTMLElement {
		constructor() {
			super();
			this.el = this;

			const urlParams = new URLSearchParams(window.location.search);
			this.storeId = urlParams.get('storeId');
			if (!this.storeId) this.storeNotFound();
			if (!this.storeId) return;



			this.init();
		}
		async init() {

			const locations = await this.fetchStores();
			await this.initStore(locations);
		}

		async initStore(locations) {
			const location = locations.find(location => location.storeId === this.storeId);
			if (!location) this.storeNotFound();
			if (!location) return;
			const storeName = cleanUpBrokenCharacters(location['name']);
			const storeRoad = cleanUpBrokenCharacters(location['address']['address1']);
			let storeZip = cleanUpBrokenCharacters(location['address']['zip']);
			if (storeZip === undefined || storeZip === null) storeZip = cleanUpBrokenCharacters(location['address']['postal_code']);
			if (storeZip === undefined || storeZip === null) storeZip = '';

			let address2 = cleanUpBrokenCharacters(location['address']['address2']);
			if (address2 === undefined || storeZip === null) address2 = cleanUpBrokenCharacters(location['address']['address2']);
			if (address2 === undefined || storeZip === null) address2 = '';

			const storeCity = cleanUpBrokenCharacters(location['address']['city']);
			const storeAddress = cleanUpBrokenCharacters(storeRoad) + ', ' + address2 + ' ' + storeZip + ' ' + cleanUpBrokenCharacters(storeCity);
			const storePhoneNr = location['address']['phone'];
			const openingHours = location.openingHours;
			const storeEmail = location['email']
			this.el.querySelector('.store_card__shop_name').innerText = storeName ? storeName : '';
			this.el.querySelector('.store_card__shop_address').innerText = storeAddress ? storeAddress : '';
			const storePosition = {
				lat: location['address']['latitude'],
				lng: location['address']['longitude']
			}
			const storeEmailElement = this.el.querySelector('.store_card__shop_email');
			if (storeEmail && storeEmailElement) {
				storeEmailElement.innerText = storeEmail;
				storeEmailElement.closest('a').setAttribute('href', `mailto:${storeEmail}`)
			}

			const openingStatusText = findCurrentOpeningStatus(location.openingHours);
			const openingHoursHtml = this.wrapFirstWord(openingHours);

			this.el.querySelector('.store_card__shop_info').innerHTML = openingHoursHtml ? openingHoursHtml : '';
			this.el.querySelector('.store_card__shop_current_opening_status').innerHTML = openingStatusText ? openingStatusText : '';
			addDirectionsLink(this.el, storeAddress);

			this.initCall(this.el, storePhoneNr);
			this.initDirections();
			this.updateBreadcrumbs(storeName);
			this.showStorePage();

			const map = this.initializeMap(storePosition);

			const mapPosition = new google.maps.LatLng(storePosition.lat, storePosition.lng, map);
			this.addMarker(mapPosition, map);

			await this.userLocation(location);
		}

		initializeMap(storePosition) {
			const map = new google.maps.Map(document.getElementById('map'), {
				zoom: 15,
				center: storePosition,
				mapTypeId: 'terrain',
				disableDefaultUI: true,
				styles: [
					{
						elementType: 'geometry',
						stylers: [{ color: '#025582' }]
					},
					{
						elementType: 'labels.text.fill',
						stylers: [{ color: '#333333' }]
					},
					{
						featureType: 'road',
						elementType: 'geometry',
						stylers: [{ color: '#00283F' }]
					},
					{
						featureType: 'water',
						elementType: 'geometry.fill',
						stylers: [{ color: '#F0EDEB' }]
					},
					{
						featureType: 'poi',
						elementType: 'geometry',
						stylers: [{ visibility: 'off' }]
					},

				]
			});
			return map;
		}

		initCall(el, storePhoneNr) {
			let storePhonePrefix = '';
			if (storePhoneNr && el.querySelector('.store_card__shop_phone')) {
				if (storePhoneNr.includes('+45')) {
					storePhonePrefix = storePhoneNr.slice(0, 3);
					storePhoneNr = storePhoneNr.slice(3);
				}
				const storePhoneElement = this.el.querySelector('.store_card__shop_phone');
				if (!storePhoneElement) return;
				storePhoneElement.innerText = storePhonePrefix + ' ' + storePhoneNr;
				storePhoneElement.closest('a').setAttribute('href', `tel: ${storePhonePrefix + ' ' + storePhoneNr}`)

			}

			const call = document.querySelector('.call');
			if (call) {
				const callLink = call.querySelector('a');
				if (callLink) {
					callLink.setAttribute('href', `tel:${storePhoneNr}`)

					call.addEventListener('click', function () {
						const callLinkHref = callLink.getAttribute('href');
						window.open(callLinkHref);

					})

				}
			}
		}

		updateBreadcrumbs(storeName) {
			const breadcrumbs = document.querySelectorAll('nav.breadcrumbs');
			if (breadcrumbs) {
				breadcrumbs.forEach(breadcrumb => {
					const breadcrumbsCurrent = breadcrumb.querySelector('.breadcrumbs__current');
					if (breadcrumbsCurrent) {
						breadcrumbsCurrent.innerText = storeName;
					}
				})
			}
		}
		initDirections() {
			const directions = document.querySelector('.directions');
			if (directions) {
				directions.addEventListener('click', function () {
					const directionsLink = directions.querySelector('a');
					if (directionsLink) {
						const directionsLinkHref = directionsLink.getAttribute('href');
						window.open(directionsLinkHref, '_blank');

					}
				})
			}
		}

		async userLocation(location) {
			try {
				const userLocationObj = await this.findUserLocation();
				if (userLocationObj !== null) {
					const userLocation = {
						lat: userLocationObj.coords.latitude,
						lng: userLocationObj.coords.longitude,
					}
					const storeDistance = getStoreDistance(location, userLocation);
					this.el.querySelector('.store_card__shop_distance span').innerText = storeDistance ? storeDistance.toFixed(2) : '';

				}
			} catch (e) {
				this.el.querySelector('.store_card__shop_distance').classList.add('d-none');
				throw new Error("Error while fetching user location", e);

			}
		}

		addMarker(position, map) {
			const mapIcon = document.querySelector('.map_marker svg');
			try {
				const svgString = new XMLSerializer().serializeToString(mapIcon);
				const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;

				const marker = new google.maps.Marker({
					position: position,
					map: map,
					icon: svgDataUrl
				});
			} catch (e) {
				console.warn("error::", e);
			}

		}

		showStorePage() {
			if (document.querySelector('.store_card__wrapper--left .store__content--wrapper')) {
				document.querySelector('.store__content--wrapper').classList.remove('d-none');
			}
		}

		wrapFirstWord(text) {
			if (typeof text !== 'string') {
				throw new Error("Input must be a string");
			}

			return text
				.split('\n')
				.map(line => {
					if (!line.trim()) return line;

					const [firstWord, ...rest] = line.split(' ');

					if (!firstWord) return line;
					return `<div><span class="first-word">${firstWord}</span> <span class="rest">${rest.join(' ')}</span></div>`;
				})
				.join('\n');
		}


		storeNotFound() {
			if (document.querySelector('store-details')) {

				document.querySelector('store-details').insertAdjacentHTML('beforeend', `<h1 class='store-not-found'> ${theme.strings.store_not_found}</h1>`)
			}
		}

		async getUserLocation() {
			try {
				const position = await findUserLocation();
			} catch (error) {
				console.error('Error fetching location:', error);
			}
		}

		findUserLocation() {
			return new Promise((resolve, reject) => {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						position => resolve(position),  // Success callback
						error => reject(error)          // Error callback
					);
				} else {
					reject(new Error('Geolocation is not supported by this browser.'));
				}
			});
		}

		async fetchStores() {
			try {
				const storesResp = await fetch('https://netlify.blacklemon.dk/.netlify/functions/getStores?store=ny-form');
				const apiLocations = await storesResp.json();
				return apiLocations;
			} catch (e) {
				throw new Error("Could not fetch location data", e);
			}
		}

	}
	customElements.define('store-details', StoreDetails);
}